export default __webpack_public_path__ + "static/media/kitchen3-afterG-2048w.09de6aa3.avif";